import { useState, useEffect } from 'react';
import { pagesApi, systemPagesSeoApi } from '../lib/cms';
import { useSEO } from './useSEO';

export function usePageSEO(slug: string, fallbackTitle?: string) {
    const [pageData, setPageData] = useState<any>(null);
    const [systemSeo, setSystemSeo] = useState<any>(null);

    useEffect(() => {
        // Pobierz SEO z tabeli stron CMS
        pagesApi.getBySlug(slug)
            .then(data => {
                if (data) setPageData(data);
            })
            .catch(console.error);
        
        // Pobierz SEO z tabeli stron systemowych
        systemPagesSeoApi.getBySlug(slug)
            .then(data => {
                if (data) setSystemSeo(data);
            })
            .catch(console.error);
    }, [slug]);

    // Łącz dane: systemowe SEO nadpisuje CMS SEO
    const seoTitle = systemSeo?.seo_title || pageData?.seo_title || pageData?.title || fallbackTitle;
    const seoDesc = systemSeo?.seo_description || pageData?.seo_description;
    const seoImage = systemSeo?.seo_og_image || pageData?.seo_og_image;

    useSEO({
        title: seoTitle,
        description: seoDesc,
        image: seoImage,
        url: window.location.href,
        noindex: pageData?.status !== 'published' && !!pageData && !systemSeo
    });

    return pageData || systemSeo;
}
